import { ClaimCorrectionFormType } from '@uplift/types';
import { FormikErrors, yupToFormErrors } from 'formik';
import { array, object, string } from 'yup';

export const claimCorrectionNoteValidation = object({
  diagnosis: array().of(string())
    .when([ 'claim.diagnosis_field_toggle' ], {
      is: ( diagnosisFieldToggle: boolean) => diagnosisFieldToggle,
      then: s => s.required().min(1, 'Please add at least one diagnosis'),
      otherwise: s => s.notRequired().nullable()
    }),
  cptCodes: string()
    .when([ 'claim.cpt_field_toggle' ], {
      is: (cptFieldToggle: boolean) => cptFieldToggle,
      then: s => s.nullable().required('Please select a CPT code'),
      otherwise: s => s.notRequired().nullable()
    }),
});

// This function is necessary to merge server form validations with yup
export const runValidate = async (values: ClaimCorrectionFormType): Promise<FormikErrors<ClaimCorrectionFormType>> => {
  try {
    await claimCorrectionNoteValidation.validate(values, { abortEarly: false });

    return {};
  } catch (err) {
    return yupToFormErrors(err);
  }
};
